import styled, { css } from 'styled-components';
import { spacing } from '@izettle/otto';
import { ModalSize } from '../../../enumerations/modal-size.js';

const ModalFooterFill = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ModalFooterFill",
  componentId: "zettle__sc-itgnnp-0"
})(["margin-right:auto;margin-top:0 !important;"]);
const ifSmall = (yes, no) => _ref => {
  let {
    size
  } = _ref;
  return size === ModalSize.Small ? yes : no;
};
const mixinFooterMobile = _ref2 => {
  let {
    isMobile
  } = _ref2;
  return isMobile ? css`
        padding: ${spacing.small};
        flex-direction: column-reverse;
        align-items: stretch;
        > * + * {
          margin-bottom: ${spacing.medium};
        }
      ` : css`
        padding: ${spacing.medium};
        padding-bottom: 0;
        flex-direction: row;
        align-items: center;
        > * + * {
          margin-left: ${ifSmall(spacing.xxSmall, spacing.medium)};
        }
      `;
};
const ModalFooterContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ModalFooterContainer",
  componentId: "zettle__sc-itgnnp-1"
})(["display:flex;justify-content:flex-end;min-height:fit-content;", ""], mixinFooterMobile);
const mixinFooterSpecializedActionsContainer = _ref3 => {
  let {
    isMobile
  } = _ref3;
  return isMobile ? css`
        margin: -${ifSmall(spacing.tiny, spacing.xSmall)};
        margin-bottom: calc(
          -${ifSmall(spacing.xSmall, `${spacing.medium} + ${spacing.tiny}`)}
        );
        flex-wrap: wrap-reverse;
        > * {
          flex: 2 1 40%;
          margin: ${ifSmall(spacing.tiny, spacing.xSmall)};
        }
      ` : css`
        > * + * {
          margin-left: ${ifSmall(spacing.xxSmall, spacing.medium)};
        }
      `;
};
const ModalFooterSpecializedActionsContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__ModalFooterSpecializedActionsContainer",
  componentId: "zettle__sc-itgnnp-2"
})(["display:flex;", ""], mixinFooterSpecializedActionsContainer);

export { ModalFooterContainer, ModalFooterFill, ModalFooterSpecializedActionsContainer };
//# sourceMappingURL=styles.js.map
